import $ from 'jquery';
const CONTAINER_SELECTOR = '.js__checkbox-tree-sync';
const PARENT_ROW_SELECTOR = '.js__checkbox-tree-parent-row';
const CHILD_ROW_SELECTOR = '.js__checkbox-tree-child-row';
const CHECKBOX_SELECTOR = 'input[type="checkbox"]';
const EVENT_NAMESPACE = '.checkboxTreeSync';
export default class CheckboxTreeSync {
    static init($root = $('body')) {
        const $containers = $root.find(CONTAINER_SELECTOR);
        if (!$containers.length) {
            return;
        }
        $containers.each((i, container) => {
            this.initContainer($(container));
        });
    }
    static initContainer($container) {
        const relations = this.resolveRelations($container);
        if (!relations.length) {
            return;
        }
        relations.forEach(relation => {
            this.bindParentToChildren(relation);
            this.bindChildrenToParent(relation);
            this.syncParentWithCheckedChildren(relation);
        });
    }
    static resolveRelations($container) {
        const relations = [];
        $container.find(PARENT_ROW_SELECTOR).each((i, parentRow) => {
            const $parentRow = $(parentRow);
            const parentId = String($parentRow.data('checkbox-tree-parent-row'));
            if (!parentId) {
                return;
            }
            const $parent = $parentRow.find(CHECKBOX_SELECTOR).first();
            const $children = $container
                .find(CHILD_ROW_SELECTOR)
                .filter((i, childRow) => String($(childRow).data('checkbox-tree-child-row')) === parentId)
                .find(CHECKBOX_SELECTOR);
            if (!$parent.length || !$children.length) {
                return;
            }
            relations.push({
                $parent,
                $children,
            });
        });
        return relations;
    }
    static bindParentToChildren(relation) {
        relation.$parent.off(`change${EVENT_NAMESPACE}`).on(`change${EVENT_NAMESPACE}`, e => {
            const $parent = $(e.currentTarget);
            if ($parent.prop('checked')) {
                return;
            }
            relation.$children.prop('checked', false).trigger('change');
        });
    }
    static bindChildrenToParent(relation) {
        relation.$children.off(`change${EVENT_NAMESPACE}`).on(`change${EVENT_NAMESPACE}`, () => {
            const hasCheckedChildren = relation.$children.filter(':checked').length > 0;
            if (hasCheckedChildren && !relation.$parent.prop('checked')) {
                relation.$parent.prop('checked', true).trigger('change');
                return;
            }
            if (!hasCheckedChildren && relation.$parent.prop('checked')) {
                relation.$parent.prop('checked', false).trigger('change');
            }
        });
    }
    static syncParentWithCheckedChildren(relation) {
        if (!relation.$children.filter(':checked').length || relation.$parent.prop('checked')) {
            return;
        }
        relation.$parent.prop('checked', true);
    }
}
